import { useEffect } from "react";
import { LanguageApi } from "../system/api/LanguageApi";
import { actions, store } from "../redux";
import {apiLanguageTranslationsResponse, LanguageContent} from "../system/types/api/languageApi";
import { localStorageHelper } from "../system/helper/localStorage";
import { localStorageConfig } from "../system/config/localStorage";
import { dispatch } from "../App";

const useLoadTranslations = () => {

    const loadTranslations = async () => {
        const api = new LanguageApi();

        const state = store.getState();
        const isoCode = state.system.appConfig.language;

        const response = await api.getTranslationsLanguage(isoCode);

        if (typeof response === 'undefined') {
            loadTranslationsFromStorage();
            return;
        }

        if (response.code === 200) {
            checkTranslations(response);
        }
    };

    const checkTranslations = (response: apiLanguageTranslationsResponse) => {
        const localStorage = new localStorageHelper();

        const storageChecksum = localStorage.getItem<string>(localStorageConfig.languageChecksum);
        const state = store.getState();
        const isoCode = state.system.appConfig.language;

        if (storageChecksum !== response.data.checksum) {
            const newLang = response.data[isoCode];

            if (typeof newLang === 'string') {
                return;
            }

            localStorage.setItem(localStorageConfig.languageData, newLang);

            const state = store.getState();

            const newAppConfig = {
                ...state.system.appConfig,
                translations: newLang
            };
    
            dispatch(actions.system.setAppConfig(newAppConfig));
        }
    };

    const loadTranslationsFromStorage = () => {
        const localStorage = new localStorageHelper();
        const langData = localStorage.getItem<LanguageContent>(localStorageConfig.languageData);
        if (typeof langData === 'undefined' || langData === null){
            return;
        }

        const state = store.getState();
        const newAppConfig = {
            ...state.system.appConfig,
            translations: langData
        };

        dispatch(actions.system.setAppConfig(newAppConfig));
    }

    useEffect(() => {
        loadTranslations();
    }, []);

    return { loadTranslations };
};

export  { useLoadTranslations };
